import Cookies from 'js-cookie'
import Loader from 'react-loader-spinner'
import {AiFillStar} from 'react-icons/ai'
import {MdLocationOn} from 'react-icons/md'
import {BsBriefcaseFill} from 'react-icons/bs'
import {FiExternalLink} from 'react-icons/fi'
import {Component} from 'react'
import Header from '../Header'
import './index.css'

const statusOfApi = {
  initial: 'INTIAL',
  success: 'SUCCESS',
  failure: 'FAILURE',
}

class JobItemDetails extends Component {
  state = {
    isLoader: true,
    jobDetails: [],
    skills: [],
    companyLife: [],
    similarList: [],
    apiStatus: statusOfApi.initial,
  }

  componentDidMount() {
    this.getJobDetails()
  }

  getJobDetails = async () => {
    this.setState({isLoader: true})
    const jwtToken = Cookies.get('jwt_token')
    const {match} = this.props
    const {params} = match
    const {id} = params
    const jobsUrl = `https://apis.ccbp.in/jobs/${id}`
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }
    const response = await fetch(jobsUrl, options)
    if (response.ok === true) {
      const data = await response.json()
      const similarData = data.similar_jobs.map(eachJob => ({
        siCompanyLogo: eachJob.company_logo_url,
        siEmploymentType: eachJob.employment_type,
        siId: eachJob.id,
        siJobDescription: eachJob.job_description,
        siLocation: eachJob.location,
        siRating: eachJob.rating,
        siTitle: eachJob.title,
      }))
      const life = data.job_details.life_at_company
      const lifeAtCompany = {
        description: life.description,
        imageUrl: life.image_url,
      }
      console.log(data)
      const skillsData = data.job_details.skills.map(eachSkill => ({
        imageUrl: eachSkill.image_url,
        name: eachSkill.name,
      }))
      const eachJob = data.job_details
      const detailsOfJob = {
        companyLogo: eachJob.company_logo_url,
        companyWebsiteUrl: eachJob.company_website_url,
        employmentType: eachJob.employment_type,
        id: eachJob.id,
        jobDescription: eachJob.job_description,
        location: eachJob.location,
        packagePerAnnum: eachJob.package_per_annum,
        rating: eachJob.rating,
        title: eachJob.title,
      }
      this.setState({
        jobDetails: detailsOfJob,
        skills: skillsData,
        companyLife: lifeAtCompany,
        similarList: similarData,
        apiStatus: statusOfApi.success,
        isLoader: false,
      })
    } else {
      this.setState({isLoader: false, apiStatus: statusOfApi.failure})
    }
  }

  retryButton = () => {
    this.getJobDetails()
  }

  jobDetailsFun = () => {
    const {jobDetails, skills, companyLife, similarList} = this.state
    const {
      companyLogo,
      companyWebsiteUrl,
      employmentType,
      jobDescription,
      location,
      packagePerAnnum,
      rating,
      title,
    } = jobDetails

    return (
      <>
        <div className="job-details-container">
          <li className="jobs-card-list1">
            <div className="job-card-container1">
              <div className="job-logo-container">
                <img
                  className="company-logo"
                  src={companyLogo}
                  alt="job details company logo"
                />
                <div className="company-name-container">
                  <h1 className="title-text">{title}</h1>
                  <div className="star-container">
                    <AiFillStar className="start-icon" />
                    <p className="rating-text">{rating}</p>
                  </div>
                </div>
              </div>
              <div className="middle-container">
                <div className="location-and-type-container">
                  <div className="location-container">
                    <MdLocationOn className="location-icon" />
                    <p className="location-text">{location}</p>
                  </div>
                  <div className="location-container">
                    <BsBriefcaseFill className="location-icon" />
                    <p className="location-text">{employmentType}</p>
                  </div>
                </div>
                <p className="package-text">{packagePerAnnum}</p>
              </div>

              <hr className="line-job" />
              <div className="description-visit-container">
                <h1 className="job-description-title">Description</h1>

                <a
                  className="link-element"
                  href={companyWebsiteUrl}
                  rel="noopener noreferrer"
                >
                  Visit <FiExternalLink />
                </a>
              </div>
              <p className="descrition-text">{jobDescription}</p>
              <h1 className="skills-title">Skills</h1>
              <ul className="unorder-skills">
                {skills.map(eachSkill => (
                  <li className="list-skill" key={eachSkill.name}>
                    <div className="skill-container">
                      <img
                        className="skill-image"
                        src={eachSkill.imageUrl}
                        alt={eachSkill.name}
                      />
                      <p className="name-text">{eachSkill.name}</p>
                    </div>
                  </li>
                ))}
              </ul>
              <h1 className="skills-title">Life at Company</h1>
              <div className="companyLife-container">
                <div className="description">
                  <p className="text-desc">{companyLife.description}</p>
                </div>
                <img
                  className="life-image"
                  src={companyLife.imageUrl}
                  alt="life at company"
                />
              </div>
            </div>
          </li>
        </div>

        <div className="bottom-container">
          <h1 className="similar-heading">Similar Jobs</h1>
          <ul className="un-order-similar-container">
            {similarList.map(eachItem => (
              <li className="list-type" key={eachItem.siId}>
                <div className="similar-con">
                  <div className="job-logo-container">
                    <img
                      className="company-logo"
                      src={eachItem.siCompanyLogo}
                      alt="similar job company logo"
                    />
                    <div className="company-name-container">
                      <h1 className="title-text">{eachItem.siTitle}</h1>
                      <div className="star-container">
                        <AiFillStar className="start-icon" />
                        <p className="rating-text">{eachItem.siRating}</p>
                      </div>
                    </div>
                  </div>
                  <h1 className="des">Description</h1>
                  <p className="desc">{eachItem.siJobDescription}</p>
                  <div className="location-and-type-container">
                    <div className="location-container">
                      <MdLocationOn className="location-icon" />
                      <p className="location-text">{eachItem.siLocation}</p>
                    </div>
                    <div className="location-container">
                      <BsBriefcaseFill className="location-icon" />
                      <p className="location-text">
                        {eachItem.siEmploymentType}
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </>
    )
  }

  failureApiFun = () => (
    <div className="failuer-Container">
      <img
        className="failure-image"
        src="https://assets.ccbp.in/frontend/react-js/failure-img.png"
        alt="failure view"
      />
      <h1 className="failuer-heading">Oops! Something Went Wrong</h1>
      <p className="failuer-text">
        We cannot seem to find the page you are looking for
      </p>
      <button type="button" className="retry-button" onClick={this.retryButton}>
        Retry
      </button>
    </div>
  )

  findApiStatus = () => {
    const {apiStatus} = this.state
    switch (apiStatus) {
      case statusOfApi.success:
        return this.jobDetailsFun()
      case statusOfApi.failure:
        return this.failureApiFun()
      default:
        return null
    }
  }

  render() {
    const {isLoader} = this.state

    return (
      <>
        <Header />
        <div className="main-details-container">
          {isLoader ? (
            <div className="loader-container" testid="loader">
              <Loader type="ThreeDots" color="#ffffff" height="50" width="50" />
            </div>
          ) : (
            this.findApiStatus()
          )}
        </div>
      </>
    )
  }
}

export default JobItemDetails
